export default "__VITE_ASSET__BHl_kX1a__"